import React from "react";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiGit,
  DiJava,
  DiAndroid,
  DiMysql,
} from "react-icons/di";
import {
  SiFirebase,
  SiPostgresql,
  SiFlutter,
} from "react-icons/si";

const technologies = [
  { name: "JavaScript", icon: <DiJavascript1 color="#FFD700" /> },
  { name: "Flutter", icon: <SiFlutter color="#4285F4" /> },
  { name: "Node.js", icon: <DiNodejs color="#339933" /> },
  { name: "React", icon: <DiReact color="#61DAFB" /> },
  { name: "Android", icon: <DiAndroid color="#3DDC84" /> },
  { name: "MySQL", icon: <DiMysql color="#00758F" /> },
  { name: "Git", icon: <DiGit color="#e34c26" /> },
  { name: "Firebase", icon: <SiFirebase color="#F8E231" /> },
  { name: "PostgreSQL", icon: <SiPostgresql color="#4169E1" /> },
  { name: "Java", icon: <DiJava color="#B00000" /> },
];

function Techstack() {
  return (
    <div className="stack-grid">
      {technologies.map(({ name, icon }) => (
        <div className="tech-icons" key={name} title={name}>
          <span className="tech-icon-glyph" aria-hidden="true">
            {icon}
          </span>
          <span className="tech-icon-label">{name}</span>
        </div>
      ))}
    </div>
  );
}

export default Techstack;
